<template>
  <div class="flex flex-col">
    <div class="w-full flex flex-row gap-2 nxp-nav-container mb-8">
      <button @click="() => changeButton(0)" class="nxp-nav-button"
        :class="buttons[0].activated ? 'nxp-nav-button-active' : ''"
        :style="buttons[0].activated ? { borderColor: color } : ''">
        <bolt :fillColor="buttons[0].activated ? color : 'transparent'" :strokeColor="color" size="15" />
        <p>{{ buttons[0].label }}</p>
      </button>
      <button @click="() => changeButton(1)" class="nxp-nav-button"
        :class="buttons[1].activated ? 'nxp-nav-button-active' : ''"
        :style="buttons[1].activated ? { borderColor: color } : ''">
        {{ buttons[1].label }}
      </button>
      <button @click="() => changeButton(2)" class="nxp-nav-button"
        :class="buttons[2].activated ? 'nxp-nav-button-active' : ''"
        :style="buttons[2].activated ? { borderColor: color } : ''">
        {{ buttons[2].label }}
      </button>

    </div>
    <div class="flex flex-col gap-10">
      <recrutest-banner />
      <div>
        <div v-if="buttons[0].activated">
          <div
              v-if="!hasCurriculum"
              class="text-center"
          >
            <p>
              Você ainda não adicionou o currículo!
            </p>
            <vs-button
              color="primary"
              type="filled"
              @click="$router.push({ name: 'edit-basic-info' })"
              class="mt-5"
            >Envie seu Currículo</vs-button>
          </div>
          <div v-else>
            <div class="similar-top-row px-4">
              <div class="similar-top-left-column">
                <p class="nxp-vacancy-company">Confira estas oportunidades perfeitas para você</p>
                <skeleton-loader v-if="isLoadingSimilar" width="123px"/>
                <div v-else class="similar-pagination-summary-row">
                  <p class="similar-pagination-inline-info">
                    {{ similarRangeSummary }}
                  </p>
                  <button
                    v-if="isBulkApplying"
                    class="similar-pagination-link-action"
                    type="button"
                    @click="toggleAllSimilarsOnPage"
                  >
                    <span v-if="allSimilarsOnPageSelected">Limpar seleção</span>
                    <span v-else>Selecionar todas as vagas desta página <b>({{ similars.length }})</b></span>
                  </button>
                </div>
              </div>
              <div v-if="similars.length > 0 && !isLoadingSimilar" class="similar-bulk-actions-buttons">
                <button
                  class="nxp-card-button-vacancy"
                  :class="isBulkApplying ? 'outlined' : 'primary'"
                  type="button"
                  @click="toggleBulkSelectionMode"
                >
                  {{ isBulkApplying ? "Cancelar" : "Selecionar vagas" }}
                </button>
              </div>
            </div>
            <div v-if="isLoadingSimilar" class="similar-loading-container">
              <ReLoading :color="color" />
              <div class="similar-loading-text">
                <h2>Procurando vagas para você...</h2>
                <p>Isto pode levar alguns segundos</p>
              </div>
            </div>
            <div v-else>
              <div v-if="similars.length > 0">
                <div class="nxp-vacancy-cards">
                  <div v-for="similar in similars" :key="`similar-${similar.id}`">
                    <div
                      class="similar-vacancy-card-wrapper"
                      :class="{ 'similar-vacancy-card-wrapper-selected': selectedSimilarVacancyIds.includes(similar.id) }"
                    >
                      <label
                        v-if="isBulkApplying"
                        class="similar-vacancy-checkbox"
                        @click.stop
                      >
                        <input
                          type="checkbox"
                          :checked="selectedSimilarVacancyIds.includes(similar.id)"
                          @change="toggleSimilarSelection(similar.id)"
                        />
                      </label>
                      <VacancyCard
                        :isOpen="true"
                        :vacancy="similar"
                        :isSimilar="true"
                        :displayUnsubscribe="false"
                        :isLoading="isLoading"
                      />
                    </div>
                  </div>
                </div>
                <vs-pagination
                  class="my-5"
                  :total="similar_pagination_total"
                  v-model="similar_pagination_current"
                />
              </div>
              <div v-else>
                <VacancyEmptyCard
                  v-if="similars_error"
                  title="Não foi possível carregar as vagas"
                  description="Parece que ocorreu uma falha ao carregar as vagas, tente atualizar a página ou aperte Ctrl+F5, se o problema persistir tente novamente mais tarde."
                />
                <VacancyEmptyCard
                  v-else
                  title="Por enquanto, não foi possível encontrar nenhuma sugestão de vaga para você"
                  description="Se você acabou de enviar seu Currículo, aguarde alguns instantes, e depois, tente novamente!"
              />
              </div>
            </div>
          </div>
          <div class="nxp-other-oportunities">
            <h3>Encontre outras oportunidades</h3>
            <div class="featured-container">
              <div class="featured" @click="handleEmpregosClick">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="40" height="40" rx="20" fill="#4169E1" fill-opacity="0.18"/>
                  <path d="M14.4437 21.4146C14.6675 21.4146 14.8575 21.3368 15.0137 21.1812C15.1699 21.0257 15.2479 20.8359 15.2479 20.6121C15.2479 20.3883 15.1701 20.1983 15.0146 20.0421C14.859 19.8859 14.6693 19.8079 14.4454 19.8079C14.2217 19.8079 14.0317 19.8857 13.8754 20.0412C13.7193 20.1968 13.6412 20.3865 13.6412 20.6104C13.6412 20.8341 13.719 21.0241 13.8746 21.1804C14.0301 21.3365 14.2199 21.4146 14.4437 21.4146ZM14.4437 16.9701C14.6675 16.9701 14.8575 16.8923 15.0137 16.7368C15.1699 16.5812 15.2479 16.3915 15.2479 16.1676C15.2479 15.9439 15.1701 15.7539 15.0146 15.5976C14.859 15.4415 14.6693 15.3634 14.4454 15.3634C14.2217 15.3634 14.0317 15.4412 13.8754 15.5968C13.7193 15.7523 13.6412 15.9421 13.6412 16.1659C13.6412 16.3896 13.719 16.5796 13.8746 16.7359C14.0301 16.8921 14.2199 16.9701 14.4437 16.9701ZM16.731 21.3093H26.389V19.9132H16.731V21.3093ZM16.731 16.8648H26.389V15.4687H16.731V16.8648ZM16.2465 28.9446V26.7223H11.1826C10.705 26.7223 10.296 26.5521 9.95541 26.2115C9.61486 25.8709 9.44458 25.4619 9.44458 24.9843V11.7937C9.44458 11.3161 9.61486 10.9071 9.95541 10.5665C10.296 10.2259 10.705 10.0557 11.1826 10.0557H28.8176C29.2952 10.0557 29.7043 10.2259 30.0449 10.5665C30.3854 10.9071 30.5557 11.3161 30.5557 11.7937V24.9843C30.5557 25.4619 30.3854 25.8709 30.0449 26.2115C29.7043 26.5521 29.2952 26.7223 28.8176 26.7223H23.7537V28.9446H16.2465ZM11.1826 25.3262H28.8176C28.9032 25.3262 28.9816 25.2907 29.0529 25.2196C29.124 25.1483 29.1596 25.0698 29.1596 24.9843V11.7937C29.1596 11.7082 29.124 11.6297 29.0529 11.5584C28.9816 11.4873 28.9032 11.4518 28.8176 11.4518H11.1826C11.0971 11.4518 11.0187 11.4873 10.9474 11.5584C10.8762 11.6297 10.8407 11.7082 10.8407 11.7937V24.9843C10.8407 25.0698 10.8762 25.1483 10.9474 25.2196C11.0187 25.2907 11.0971 25.3262 11.1826 25.3262Z"
                  fill="#4169E1"/>
                </svg>
                <div class="content">
                  <h4>Acesse a Recrutei Empregos</h4>
                  <p>Confira outras vagas disponíveis</p>
                </div>
              </div>
              <div class="featured" @click="handleTelegramClick">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="40" height="40" rx="20" fill="#4169E1" fill-opacity="0.18"/>
                  <path d="M14.4437 21.4146C14.6675 21.4146 14.8575 21.3368 15.0137 21.1812C15.1699 21.0257 15.2479 20.8359 15.2479 20.6121C15.2479 20.3883 15.1701 20.1983 15.0146 20.0421C14.859 19.8859 14.6693 19.8079 14.4454 19.8079C14.2217 19.8079 14.0317 19.8857 13.8754 20.0412C13.7193 20.1968 13.6412 20.3865 13.6412 20.6104C13.6412 20.8341 13.719 21.0241 13.8746 21.1804C14.0301 21.3365 14.2199 21.4146 14.4437 21.4146ZM14.4437 16.9701C14.6675 16.9701 14.8575 16.8923 15.0137 16.7368C15.1699 16.5812 15.2479 16.3915 15.2479 16.1676C15.2479 15.9439 15.1701 15.7539 15.0146 15.5976C14.859 15.4415 14.6693 15.3634 14.4454 15.3634C14.2217 15.3634 14.0317 15.4412 13.8754 15.5968C13.7193 15.7523 13.6412 15.9421 13.6412 16.1659C13.6412 16.3896 13.719 16.5796 13.8746 16.7359C14.0301 16.8921 14.2199 16.9701 14.4437 16.9701ZM16.731 21.3093H26.389V19.9132H16.731V21.3093ZM16.731 16.8648H26.389V15.4687H16.731V16.8648ZM16.2465 28.9446V26.7223H11.1826C10.705 26.7223 10.296 26.5521 9.95541 26.2115C9.61486 25.8709 9.44458 25.4619 9.44458 24.9843V11.7937C9.44458 11.3161 9.61486 10.9071 9.95541 10.5665C10.296 10.2259 10.705 10.0557 11.1826 10.0557H28.8176C29.2952 10.0557 29.7043 10.2259 30.0449 10.5665C30.3854 10.9071 30.5557 11.3161 30.5557 11.7937V24.9843C30.5557 25.4619 30.3854 25.8709 30.0449 26.2115C29.7043 26.5521 29.2952 26.7223 28.8176 26.7223H23.7537V28.9446H16.2465ZM11.1826 25.3262H28.8176C28.9032 25.3262 28.9816 25.2907 29.0529 25.2196C29.124 25.1483 29.1596 25.0698 29.1596 24.9843V11.7937C29.1596 11.7082 29.124 11.6297 29.0529 11.5584C28.9816 11.4873 28.9032 11.4518 28.8176 11.4518H11.1826C11.0971 11.4518 11.0187 11.4873 10.9474 11.5584C10.8762 11.6297 10.8407 11.7082 10.8407 11.7937V24.9843C10.8407 25.0698 10.8762 25.1483 10.9474 25.2196C11.0187 25.2907 11.0971 25.3262 11.1826 25.3262Z"
                  fill="#4169E1"/>
                </svg>
                <div class="content">
                  <h4>Entre no nosso grupo do Telegram</h4>
                  <p>Receba diversas vagas de emprego</p>
                </div>
              </div>
            </div>
            <!-- Hogwarts Quiz Promo Card -->
            <!-- <div class="hogwarts-card" @click="handleHogwartsQuizClick">
              <img src="@/assets/images/hogwarts_quiz.png" alt="">
              <div class="content">
                <h3>Qual sua Casa em Hogwarts? 🪄</h3>
                <p>
                  Descubra em segundos sua casa com base no seu perfil comportamental e compartilhe com seus amigos. ⚡️
                </p>
              </div>
              <button class="quiz-button" @click.stop="handleHogwartsQuizClick">
                Fazer o Quiz agora
              </button>
            </div> -->

            <div class="talent-base" :style="`background-color: ${is_public ? '#ECEBEB' : '#4169E12E'};`">
              <h4>
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.17088 6.54057C6.39574 6.54057 5.73206 6.26411 5.17984 5.7112C4.62748 5.15828 4.3513 4.49724 4.3513 3.72807C4.3513 2.94849 4.62775 2.28391 5.18067 1.73432C5.73359 1.18488 6.39463 0.910156 7.1638 0.910156C7.94352 0.910156 8.6081 1.18488 9.15755 1.73432C9.70699 2.28391 9.98171 2.9462 9.98171 3.7212C9.98171 4.4962 9.70699 5.15981 9.15755 5.71203C8.6081 6.26439 7.94588 6.54057 7.17088 6.54057ZM7.16609 5.49349C7.66025 5.49349 8.07859 5.32043 8.42109 4.97432C8.76345 4.62807 8.93463 4.21189 8.93463 3.72578C8.93463 3.23162 8.76359 2.81328 8.4215 2.47078C8.07928 2.12842 7.66338 1.95724 7.1738 1.95724C6.68421 1.95724 6.26595 2.12828 5.919 2.47036C5.57192 2.81259 5.39838 3.22849 5.39838 3.71807C5.39838 4.20766 5.57143 4.62599 5.91755 4.97307C6.2638 5.32002 6.67998 5.49349 7.16609 5.49349ZM16.189 15.9262L13.628 13.3599C13.3321 13.5694 13.0259 13.72 12.7092 13.8118C12.3927 13.9038 12.0755 13.9497 11.7575 13.9497C10.8642 13.9497 10.1063 13.6383 9.4838 13.0154C8.8613 12.3924 8.55005 11.6361 8.55005 10.7462C8.55005 9.8562 8.8615 9.10106 9.48442 8.48078C10.1073 7.86036 10.8637 7.55016 11.7536 7.55016C12.6436 7.55016 13.3987 7.86182 14.019 8.48516C14.6394 9.10849 14.9496 9.86543 14.9496 10.756C14.9496 11.075 14.9046 11.3928 14.8144 11.7093C14.7243 12.026 14.5728 12.3322 14.3598 12.6281L16.9261 15.1891L16.189 15.9262ZM11.7498 12.9027C12.3598 12.9027 12.8712 12.6964 13.2838 12.2839C13.6963 11.8713 13.9025 11.3599 13.9025 10.7499C13.9025 10.1399 13.6963 9.62863 13.2838 9.21599C12.8712 8.80349 12.3598 8.59724 11.7498 8.59724C11.1398 8.59724 10.6285 8.80349 10.2159 9.21599C9.80338 9.62863 9.59713 10.1399 9.59713 10.7499C9.59713 11.3599 9.80338 11.8713 10.2159 12.2839C10.6285 12.6964 11.1398 12.9027 11.7498 12.9027ZM0.916504 13.0897V11.422C0.916504 10.9879 1.02664 10.6078 1.24692 10.2818C1.4672 9.95571 1.77727 9.68904 2.17713 9.48182C2.80574 9.17335 3.61998 8.88349 4.61984 8.61224C5.61956 8.34085 6.67095 8.24252 7.774 8.31724C7.67637 8.47821 7.58713 8.64682 7.5063 8.82307C7.42532 8.99918 7.36088 9.1755 7.31296 9.35203C6.27546 9.32134 5.3456 9.43481 4.52338 9.69245C3.70102 9.95009 3.07032 10.1915 2.6313 10.4166C2.42866 10.5227 2.26671 10.6631 2.14546 10.8377C2.02421 11.0124 1.96359 11.2072 1.96359 11.422V12.0427H7.21671C7.30616 12.2271 7.39393 12.4074 7.48005 12.5835C7.5663 12.7596 7.66317 12.9283 7.77067 13.0897H0.916504Z" fill="#4F4F4F"/>
                </svg>
                <span v-if="is_public">Você está inscrito na Base da Talentos Recrutei</span>
                <span v-else>Inscreva-se na Base da Talentos Recrutei para ser encontrado</span>
              </h4>
              <p v-if="is_public">
                Seu perfil está visível para milhares de recrutadores que poderão te convidar para participar de processos seletivos.
                Estes recrutadores só terão acesso a sua informações de contato quando você aceitar um convite para um processo seletivo.
              </p>
              <p v-else>Seu perfil ainda não está visível para recrutadores. Inscreva-se na base de talentos da Recrutei para ser encontrado por milhares de recrutadores e receber convites para processos seletivos. Estes recrutadores só terão acesso a sua informações de contato quando você aceitar um convite para um processo seletivo.</p>
              <div class="button-container">
                <a 
                  href="javascript:void(0)" 
                  @click="handleManageSubscriptionClick"
                >Gerenciar inscrição na Base de Talentos Recrutei</a>
                <a
                  href="https://recrutei.com.br/privacidade-e-seguranca"
                  target="_blank"
                >Política de privacidade</a>
              </div>
              <div v-if="!is_public">
                <button  class="button-signup" @click="handleSignupClick">Inscreva-se</button>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="buttons[1].activated">
          <div v-if="vacancies.length > 0" class="w-full flex flex-row justify-between px-4">
            <p class="nxp-vacancy-company">Confira as vagas da <b>{{ company.name }}</b></p>
            <p class="nxp-vacancy-list"><b>{{ vacancies.length }}</b> Vagas</p>
          </div>
          <div v-if="vacancies.length > 0" class="nxp-vacancy-cards">
            <div v-for="vacancy in vacancies" :key="`nxp-vacancy-${vacancy.id}`">
              <VacancyCard :displayUnsubscribe="false" :vacancy="vacancy" :isOpen="true" />
            </div>
          </div>
          <vs-pagination class="my-5" v-if="vacancies.length > 0" :total="vacancy_pagination_total"
            v-model="vacancy_pagination_current" />
          <div v-else class="nxp-no-data">
            <p>
              Não há mais vagas abertas na <b>{{ company.name }}</b> no momento
            </p>
            <p>
              Confira a aba de oportunidades para encontrar vagas de outras empresas,
              selecionadas para você
            </p>
          </div>
        </div>
        <div v-if="buttons[2].activated">
          <div class="w-full flex flex-row justify-between items-center applications-header px-4">
            <p class="nxp-vacancy-company">{{ applicationsHeaderLabel }}</p>
            <div class="applications-header-right">
              <v-select
                v-if="!isAnonimous"
                v-model="applicationsScope"
                :options="applicationsScopeOptions"
                :reduce="(option) => option.value"
                :clearable="false"
                :searchable="false"
                class="applications-scope-vselect"
                @input="handleApplicationsScopeChange"
              />
              <p v-if="currentApplicationsTotal > 0" class="nxp-vacancy-list">
                <b>{{ currentApplicationsTotal }}</b> Vagas
              </p>
            </div>
          </div>
          <div v-if="currentApplicationsList.length > 0" class="nxp-vacancy-cards">
            <div v-for="vacancy in currentApplicationsList" :key="`nxp-vacancy-${vacancy.id}`">
              <VacancyCard
                :displayUnsubscribe="buttons[2].activated"
                :vacancy="vacancy"
                :isOpen="false"
                :showPreInterviewButton="true"
                :prefetchedReferral="referralForVacancy(vacancy.id)"
                :hasPrefetchedReferral="hasPrefetchedReferralFor(vacancy.id)"
                :useBulkReferralPrefetch="true"
                :questionnaireStatus="questionnaireStatusFor(vacancy)"
                :hasPrefetchedQuestionnaire="hasPrefetchedQuestionnaireFor(vacancy)"
                @withdrawn="onWithdrawn"
              />
            </div>
          </div>
          <vs-pagination
            class="my-5"
            v-if="currentApplicationsList.length > 0"
            :total="currentApplicationsPaginationTotal"
            v-model="currentApplicationsPaginationCurrent"
          />
          <div v-else-if="isLoadingApplicationsAll" class="similar-loading-container">
            <ReLoading :color="color" />
            <div class="similar-loading-text">
              <h2>Carregando suas candidaturas...</h2>
            </div>
          </div>
          <div v-else class="nxp-no-data">
            <p v-if="applicationsScope === 'all'">
              Você ainda não se candidatou a nenhuma vaga.
            </p>
            <p v-else>
              Não há mais vagas abertas na <b>{{ company.name }}</b> no momento
            </p>
            <p>
              Confira a aba de oportunidades para encontrar vagas de outras empresas,
              selecionadas para você
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="success-popup-backdrop" v-if="showSuccessPopup" @click="showSuccessPopup = false">
      <div 
        class="success-popup"
      >
        <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.24707" y="0.271484" width="56" height="56" rx="28" fill="#CEEDCE"/>
          <path d="M23.9393 37.672L15.4473 29.2273L17.1875 27.4393L23.9393 34.191L39.307 18.8706L41.0473 20.6113L23.9393 37.672Z" fill="#32CD32"/>
        </svg>
        <div class="success-popup-content">
          <h2>Candidatura efetuada! 🎉</h2>
          <p>Acompanhe seu e-mail para atualizações do processo seletivo.</p>
          <img
            v-if="utm_source === 'talent.com'"
            alt="facebook-pixel"
            src="https://ca.talent.com/tracker/img-pixel.php?tracker=recrutei"
            hidden
          />
        </div>
      </div>
    </div>
    <transition name="bulk-drawer-slide">
      <div v-if="isBulkApplying" class="bulk-selection-drawer">
        <div class="bulk-selection-drawer-content">
          <p class="bulk-selection-count-text">
            <span class="bulk-selection-count-number">{{ selectedSimilarVacancyIds.length }}</span>
            {{ selectedSimilarVacancyIds.length === 1 ? "vaga" : "vagas" }}
          </p>
          <div class="bulk-selection-drawer-actions">
            <button
              type="button"
              class="nxp-card-button-vacancy outlined"
              @click="closeBulkSelectionDrawer"
            >
              Fechar
            </button>
            <button
              type="button"
              class="nxp-card-button-vacancy primary"
              :disabled="selectedSimilarVacancyIds.length === 0 || isBulkSubmitting"
              @click="openBulkConfirm"
            >
              {{
                isBulkSubmitting
                  ? "Candidatando..."
                  : selectedSimilarVacancyIds.length === 0
                    ? "Selecione algumas vagas para se candidatar"
                    : "Candidatar-se nas selecionadas"
              }}
            </button>
          </div>
        </div>
      </div>
    </transition>
    <vs-popup
      class="bulk-confirm-popup"
      title="Confirmar candidatura em massa"
      :active.sync="bulkConfirmActive"
      :button-close-hidden="isBulkSubmitting"
    >
      <div class="bulk-confirm-content">
        <div class="bulk-confirm-icon-wrapper">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="24" fill="#C8E0FF"/>
            <path d="M24 14V34M14 24H34" stroke="#4169E1" stroke-width="2.5" stroke-linecap="round"/>
          </svg>
        </div>
        <h3 class="bulk-confirm-title">
          Você está prestes a se candidatar em
          <span class="bulk-confirm-highlight">
            {{ selectedSimilarVacancyIds.length }}
            {{ selectedSimilarVacancyIds.length === 1 ? "vaga" : "vagas" }}
          </span>
        </h3>
        <p class="bulk-confirm-description">
          Seu currículo será enviado a todas as empresas selecionadas.
          Ao confirmar, sua candidatura será efetuada em cada uma delas e poderá ser acompanhada na aba <b>Candidaturas</b>.
        </p>
        <div class="bulk-confirm-actions">
          <vs-button
            class="bulk-confirm-cancel"
            color="dark"
            type="flat"
            :disabled="isBulkSubmitting"
            @click="closeBulkConfirm"
          >
            Revisar seleção
          </vs-button>
          <vs-button
            color="primary"
            type="filled"
            :disabled="isBulkSubmitting"
            @click="submitBulkApplications"
          >
            {{ isBulkSubmitting ? "Enviando..." : "Confirmar candidatura" }}
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VacancyCard from "../../components/dashboard/VacancyCard.vue";
import VacancyEmptyCard from "../../components/dashboard/profile-detail/VacancyEmptyCard.vue";
import { mapState } from "vuex";
import { get } from "lodash";
import vSelect from "vue-select";
import ReLoading from '../../components/re-loading/ReLoading.vue';
import Bolt from '../../components/icons/Bolt.vue';
import SkeletonLoader from '../../components/skeleton-loader/SkeletonLoader.vue';
import confetti from 'canvas-confetti';
import RecrutestBanner from '../../components/dashboard/RecrutestBanner.vue';

const LISTING_CACHE_PREFIX = "vacancy-dashboard-listing-";

function listingSessionFingerprint() {
  try {
    const t = localStorage.getItem("userToken");
    if (!t || t === "null") return "guest";
    let h = 5381;
    for (let i = 0; i < t.length; i += 1) {
      h = ((h << 5) + h) ^ t.charCodeAt(i);
    }
    return (h >>> 0).toString(36);
  } catch (_) {
    return "guest";
  }
}

export default {

  watch: {
    vacancy_pagination_current(page) {
      if (this.restoringFromCache) return;
      this.fetchVacancyPagination(page);
    },
    application_pagination_current(page) {
      if (this.restoringFromCache) return;
      this.fetchApplicationsPagination(page);
    },
    similar_pagination_current(page) {
      if (this.restoringFromCache) return;
      this.clearBulkSelection();
      this.fetchSimilarPagination(page);
    },
    applications_all_pagination_current(page) {
      if (this.restoringFromCache) return;
      this.fetchAllApplications(page);
    },
  },
  created() {
    window.scroll(0, 0);

    const hasSuccessQuery = this.$route.query.success != null && this.$route.query.success !== "";

    if (hasSuccessQuery) {
      try {
        sessionStorage.removeItem(this.getSimilarsCacheKey());
      } catch (_) {}
      try {
        sessionStorage.removeItem(this.getVacanciesCacheKey());
      } catch (_) {}
    }

    const restoredVA = !hasSuccessQuery && this.tryRestoreVacanciesFromCache();
    const restoredSimilars = !hasSuccessQuery && this.tryRestoreSimilarsFromCache();

    if (restoredVA || restoredSimilars) {
      this.restoringFromCache = true;
      this.$nextTick(() => {
        this.restoringFromCache = false;
        // Após restaurar do sessionStorage, os mapas in-memory de indicações
        // e status de questionário não são persistidos. Reidrata-os via bulk
        // se a aba "Candidaturas" já estiver ativa (cobre o retorno do
        // application-process via $router.back()).
        this.ensureReferralsForCurrentApplications();
      });
    }

    this.googleAnalytics();
    this.onMountButtonInAnonimous();
    if (!restoredVA) this.fetchVacanciesAndApplications();
    if (!restoredSimilars) this.fetchSimilarVacancies();
    this.fetchPublicStatus();
    this.checkForSuccess();
  },
  beforeDestroy() {
    this.saveSimilarsSnapshotToCache();
    this.saveVacanciesSnapshotToCache();
  },
  data() {
    return {
      restoringFromCache: false,
      isLoadingSimilar: false,
      similars: [],
      similars_error: false,
      similar_total: 0,
      similar_pagination_total: 1,
      similar_pagination_current: 1,
      similar_pagination_path: "",
      similarLoadingMinimumTime: 6000,
      empty: false,
      isLoading: false,
      vacancies: [],
      applications: [],
      buttons: [
        {
          label: "Oportunidades",
          activated: true,
          disabled: false,
        },
        {
          label: "Vagas da empresa",
          activated: false,
          disabled: false,
        },
        { 
          label: "Candidaturas",
          activated: false,
          disabled: false 
        },
      ],
      vacancy_total: 0,
      vacancy_pagination_total: 1,
      vacancy_pagination_current: 1,
      vacancy_pagination_path: "",
      application_total: 0,
      application_pagination_total: 1,
      application_pagination_current: 1,
      application_pagination_path: "",
      is_public: false,
      showSuccessPopup: false,
      isBulkApplying: false,
      selectedSimilarVacancyIds: [],
      isBulkSubmitting: false,
      bulkConfirmActive: false,
      applicationsScope: 'current',
      applicationsAll: [],
      applications_all_total: 0,
      applications_all_pagination_total: 1,
      applications_all_pagination_current: 1,
      applications_all_pagination_path: '',
      isLoadingApplicationsAll: false,
      applicationsAllLoaded: false,
      referralsByVacancyId: {},
      referralsLoadedForVacancyIds: {},
      questionnaireByApplicationId: {},
      questionnaireLoadedForApplicationIds: {},
    };
  },
  computed: {
    ...mapState("basicInfo", ["basicInfo"]),
    ...mapState("company", ["company"]),
    ...mapState("address", ["address"]),
    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
    colorSoft() {
      if (this.vacancy_status === 1)
        return this.company.base_hexcolor
          ? this.company.base_hexcolor + '2E'
          : "#1551b12E";
      else
        return this.company.base_hexcolor;
    },
    hasCurriculum() {
      return this.basicInfo.curriculum_url ? true : false;
    },
    isAnonimous() {
      const label = get(this.$router, "history.current.params.company_label", null);
      return label === "anonima";
    },
    utm_source() {
      return sessionStorage.getItem("utm_source") || "";
    },
    allSimilarsOnPageSelected() {
      return (
        this.similars.length > 0 &&
        this.similars.every((vacancy) => this.selectedSimilarVacancyIds.includes(vacancy.id))
      );
    },
    similarRangeSummary() {
      if (!this.similars.length || !this.similar_total) return "Exibindo 0 - 0 de 0 vagas";
      const page = this.similar_pagination_current || 1;
      const firstItem = (page - 1) * this.similars.length + 1;
      const lastItem = Math.min(firstItem + this.similars.length - 1, this.similar_total);
      return `Exibindo ${firstItem} - ${lastItem} de ${this.similar_total} vagas`;
    },
    currentApplicationsList() {
      return this.applicationsScope === 'all' ? this.applicationsAll : this.applications;
    },
    currentApplicationsTotal() {
      return this.applicationsScope === 'all'
        ? this.applications_all_total
        : this.application_total;
    },
    currentApplicationsPaginationTotal() {
      return this.applicationsScope === 'all'
        ? this.applications_all_pagination_total
        : this.application_pagination_total;
    },
    currentApplicationsPaginationCurrent: {
      get() {
        return this.applicationsScope === 'all'
          ? this.applications_all_pagination_current
          : this.application_pagination_current;
      },
      set(value) {
        if (this.applicationsScope === 'all') {
          this.applications_all_pagination_current = value;
        } else {
          this.application_pagination_current = value;
        }
      },
    },
    applicationsHeaderLabel() {
      if (this.applicationsScope === 'all' || this.isAnonimous) {
        return 'Veja todas as suas candidaturas';
      }
      const companyName = (this.company && this.company.name) || 'esta empresa';
      return `Veja suas candidaturas na ${companyName}`;
    },
    applicationsScopeOptions() {
      const companyName = (this.company && this.company.name) || 'esta empresa';
      return [
        { label: `Candidaturas em ${companyName}`, value: 'current' },
        { label: 'Todas as minhas candidaturas', value: 'all' },
      ];
    },
  },
  methods: {
    getSimilarsCacheKey() {
      const label = get(this.$route, "params.company_label", "");
      return `${LISTING_CACHE_PREFIX}${label}::similars::${listingSessionFingerprint()}`;
    },
    getVacanciesCacheKey() {
      const label = get(this.$route, "params.company_label", "");
      return `${LISTING_CACHE_PREFIX}${label}::va::${listingSessionFingerprint()}`;
    },
    saveSimilarsSnapshotToCache() {
      try {
        if (this.similars.length === 0) return;

        const payload = {
          similars: this.similars,
          similars_error: this.similars_error,
          similar_total: this.similar_total,
          similar_pagination_total: this.similar_pagination_total,
          similar_pagination_current: this.similar_pagination_current,
          similar_pagination_path: this.similar_pagination_path,
          isBulkApplying: this.isBulkApplying,
          selectedSimilarVacancyIds: [...this.selectedSimilarVacancyIds],
        };
        sessionStorage.setItem(this.getSimilarsCacheKey(), JSON.stringify(payload));
      } catch (_) {}
    },
    saveVacanciesSnapshotToCache() {
      try {
        if (this.vacancies.length === 0 && this.applications.length === 0) return;

        const payload = {
          vacancies: this.vacancies,
          applications: this.applications,
          vacancy_total: this.vacancy_total,
          application_total: this.application_total,
          vacancy_pagination_total: this.vacancy_pagination_total,
          vacancy_pagination_current: this.vacancy_pagination_current,
          vacancy_pagination_path: this.vacancy_pagination_path,
          application_pagination_total: this.application_pagination_total,
          application_pagination_current: this.application_pagination_current,
          application_pagination_path: this.application_pagination_path,
          empty: this.empty,
          buttons: this.buttons.map((b) => ({ ...b })),
          applicationsScope: this.applicationsScope,
          applicationsAll: this.applicationsAll,
          applications_all_total: this.applications_all_total,
          applications_all_pagination_total: this.applications_all_pagination_total,
          applications_all_pagination_current: this.applications_all_pagination_current,
          applications_all_pagination_path: this.applications_all_pagination_path,
          applicationsAllLoaded: this.applicationsAllLoaded,
        };
        sessionStorage.setItem(this.getVacanciesCacheKey(), JSON.stringify(payload));
      } catch (_) {}
    },
    tryRestoreSimilarsFromCache() {
      try {
        const cacheKey = this.getSimilarsCacheKey();
        const raw = sessionStorage.getItem(cacheKey);
        if (!raw) return false;
        const payload = JSON.parse(raw);
        sessionStorage.removeItem(cacheKey);

        this.similars = payload.similars || [];
        this.similars_error = !!payload.similars_error;
        this.similar_total = payload.similar_total || 0;
        this.similar_pagination_total = payload.similar_pagination_total || 1;
        this.similar_pagination_current = payload.similar_pagination_current || 1;
        this.similar_pagination_path = payload.similar_pagination_path || "";
        this.isBulkApplying = !!payload.isBulkApplying;
        this.selectedSimilarVacancyIds = Array.isArray(payload.selectedSimilarVacancyIds)
          ? payload.selectedSimilarVacancyIds
          : [];
        this.isLoadingSimilar = false;
        return true;
      } catch (_) {
        try {
          sessionStorage.removeItem(this.getSimilarsCacheKey());
        } catch (__) {}
        return false;
      }
    },
    tryRestoreVacanciesFromCache() {
      try {
        const cacheKey = this.getVacanciesCacheKey();
        const raw = sessionStorage.getItem(cacheKey);
        if (!raw) return false;
        const payload = JSON.parse(raw);
        sessionStorage.removeItem(cacheKey);

        this.vacancies = payload.vacancies || [];
        this.applications = payload.applications || [];
        this.vacancy_pagination_total = payload.vacancy_pagination_total || 1;
        this.vacancy_pagination_current = payload.vacancy_pagination_current || 1;
        this.vacancy_pagination_path = payload.vacancy_pagination_path || "";
        this.application_pagination_total = payload.application_pagination_total || 1;
        this.application_pagination_current = payload.application_pagination_current || 1;
        this.application_pagination_path = payload.application_pagination_path || "";
        this.vacancy_total = payload.vacancy_total || 0;
        this.application_total = payload.application_total || 0;
        this.empty = !!payload.empty;
        if (Array.isArray(payload.buttons) && payload.buttons.length === this.buttons.length) {
          payload.buttons.forEach((b, i) => {
            this.buttons[i].activated = !!b.activated;
            this.buttons[i].disabled = !!b.disabled;
          });
        }
        this.applicationsScope = payload.applicationsScope === 'all' ? 'all' : 'current';
        this.applicationsAll = Array.isArray(payload.applicationsAll) ? payload.applicationsAll : [];
        this.applications_all_total = payload.applications_all_total || 0;
        this.applications_all_pagination_total = payload.applications_all_pagination_total || 1;
        this.applications_all_pagination_current = payload.applications_all_pagination_current || 1;
        this.applications_all_pagination_path = payload.applications_all_pagination_path || '';
        this.applicationsAllLoaded = !!payload.applicationsAllLoaded;
        this.isLoading = false;
        return true;
      } catch (_) {
        try {
          sessionStorage.removeItem(this.getVacanciesCacheKey());
        } catch (__) {}
        return false;
      }
    },
    // handleHogwartsQuizClick() {
    //   (async () => {
    //     try {
    //       const { trackEvent } = await import("@/services/posthog");
    //       trackEvent("hogwarts_quiz_clicked");
    //     } catch (_) {}
    //   })();
    //   window.open('http://blog.recrutei.com.br/blog/qual-sua-casa-em-hogwarts?utm_source=talents-tab&utm_medium=btn-click', '_blank');
    // },
    handleManageSubscriptionClick(e) {
      e.preventDefault();
      const { params } = this.$router.history.current;
      this.$router.push({
        name: "dashboard-settings",
        params,
        query: {
          tab: 1,
        }
      });
    },
    async fetchVacanciesAndApplications() {
      try {
        this.isLoading = true;

        const { company_label } = this.$router.history.current.params;

        const response = await this.$http.get(
          `/api/v1/talent/${company_label}/user/talent/vacancy`
        );

        this.isLoading = false;

        const { vacancies, applications } = response.data.data;

        this.vacancy_pagination_total = get(vacancies, 'last_page', null);
        this.application_pagination_total = get(applications, 'last_page', null);

        this.vacancy_pagination_path = get(vacancies, 'path', '');
        this.application_pagination_path = get(applications, 'path', '');

        this.vacancy_pagination_current = get(vacancies, 'current_page', null);
        this.application_pagination_current = get(applications, 'current_page', null);


        if (get(vacancies, 'data.length', 0) <= 0 && get(applications, 'data.length', 0) <= 0) {
          this.empty = true;
        }

        const _applications_ids = applications.data.map((app) => app.id) || 0;

        this.vacancy_total = get(vacancies, 'total', 0) - _applications_ids.length;
        this.application_total = get(applications, 'total', 0);

        this.vacancies = get(vacancies, 'data', []).filter(
          (vacancy) => !_applications_ids.includes(vacancy.id)
        );

        this.applications = get(applications, 'data', []);
        this.ensureReferralsForCurrentApplications();
      } catch (error) {
        this.isLoading = false;
      }
    },

    fetchApplicationsPagination(page) {

      this.$http
        .get(`${this.application_pagination_path}?page=${page}`)
        .then((response) => {

          const { vacancies, applications } = response.data["data"];

          this.vacancy_total = vacancies.total;
          this.application_total = applications.total;

          this.vacancy_total = vacancies.total;
          this.application_total = applications.total;

          this.vacancy_pagination_total = vacancies.last_page;
          this.application_pagination_total = applications.last_page;

          this.vacancy_pagination_path = vacancies.path;
          this.application_pagination_path = applications.path;

          this.vacancy_pagination_current = vacancies.current_page;
          this.application_pagination_current = applications.current_page;

          if (vacancies.data.length <= 0 && applications.data.length <= 0)
            this.empty = true;

          const _applications_ids = applications.data.map((app) => app.id);

          this.vacancies = vacancies.data.filter(
            (vacancy) => !_applications_ids.includes(vacancy.id)
          );
          this.applications = applications.data;
          this.ensureReferralsForCurrentApplications();
        })
        .catch(() => {
        });
    },

    fetchVacancyPagination(page) {

      this.$http
        .get(`${this.vacancy_pagination_path}?page=${page}`)
        .then((response) => {

          const { vacancies, applications } = response.data["data"];

          this.vacancy_total = vacancies.total;
          this.application_total = applications.total;

          this.vacancy_pagination_total = vacancies.last_page;
          this.application_pagination_total = applications.last_page;

          this.vacancy_pagination_path = vacancies.path;
          this.application_pagination_path = applications.path;

          if (vacancies.data.length <= 0 && applications.data.length <= 0)
            this.empty = true;

          const _applications_ids = applications.data.map((app) => app.id);

          this.vacancies = vacancies.data.filter(
            (vacancy) => !_applications_ids.includes(vacancy.id)
          );
          this.applications = applications.data;
        })
        .catch(() => {
        });
    },

    async fetchSimilarVacancies() {
      this.isLoadingSimilar = true;
      const timerPromise = new Promise(resolve => setTimeout(resolve, this.similarLoadingMinimumTime));
      try {
        const response = await this.$http.get(
          `/api/v3/vacancies/similar`
        );
        await Promise.all([response, timerPromise]);
        
        this.isLoadingSimilar = false;

        const similars = get(response, 'data', []);

        this.similar_pagination_total = get(similars, 'last_page', null);
        this.similar_pagination_path = get(similars, 'path', '');
        this.similar_pagination_current = get(similars, 'current_page', null);
        this.similar_total = get(similars, 'total', 0);
        this.similars = get(similars, 'data', []);
        this.similars_error = false;
      } catch (error) {
        await timerPromise;
        this.isLoadingSimilar = false;
        this.similars_error = true;
      }
    },

    fetchSimilarPagination(page) {
      this.isLoading = true;

      this.$http
        .get(`${this.similar_pagination_path}?page=${page}`)
        .then((response) => {

          const similars = get(response, 'data', []);

          this.similar_total = similars.total;
          this.similar_pagination_total = get(similars, 'last_page', null);
          this.similar_pagination_path = get(similars, 'path', '');
          this.similar_pagination_current = get(similars, 'current_page', null);
          this.similars = get(similars, 'data', []);
          this.similar_total = get(similars, 'total', 0);
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async fetchAllApplications(page = 1) {
      try {
        this.isLoadingApplicationsAll = true;
        const { company_label } = this.$router.history.current.params;
        const url = this.applications_all_pagination_path
          ? `${this.applications_all_pagination_path}?page=${page}`
          : `/api/v1/talent/${company_label}/user/talent/applications/all?page=${page}`;
        const response = await this.$http.get(url);

        const applications = get(response, 'data.data.applications', {});
        this.applicationsAll = get(applications, 'data', []);
        this.applications_all_total = get(applications, 'total', 0);
        this.applications_all_pagination_total = get(applications, 'last_page', 1);
        this.applications_all_pagination_current = get(applications, 'current_page', 1);
        this.applications_all_pagination_path = get(applications, 'path', '');
        this.applicationsAllLoaded = true;
        this.ensureReferralsForCurrentApplications();
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoadingApplicationsAll = false;
      }
    },

    async fetchReferralsForVacancies(vacancyIds) {
      if (this.isAnonimous) return;
      const ids = (Array.isArray(vacancyIds) ? vacancyIds : [])
        .map((id) => Number(id))
        .filter((id) => Number.isInteger(id) && id > 0 && !this.referralsLoadedForVacancyIds[id]);

      if (ids.length === 0) return;

      try {
        const response = await this.$http.post('/api/v1/indications/show-many', {
          vacancy_ids: ids,
        });
        const data = get(response, 'data.data', {});
        const merged = { ...this.referralsByVacancyId };
        ids.forEach((id) => {
          this.$set(this.referralsLoadedForVacancyIds, id, true);
          if (data && Object.prototype.hasOwnProperty.call(data, id)) {
            merged[id] = data[id];
          } else if (data && Object.prototype.hasOwnProperty.call(data, String(id))) {
            merged[id] = data[String(id)];
          }
        });
        this.referralsByVacancyId = merged;
      } catch (error) {
        console.error(error);
      }
    },

    ensureReferralsForCurrentApplications() {
      if (!this.buttons[2] || !this.buttons[2].activated) return;
      const list = this.applicationsScope === 'all'
        ? this.applicationsAll
        : this.applications;
      if (!Array.isArray(list) || list.length === 0) return;
      this.fetchReferralsForVacancies(list.map((v) => v.id));
      const appIds = list
        .map((v) => get(v, 'applications.0.id'))
        .filter((id) => Number.isInteger(id) && id > 0);
      this.fetchQuestionnaireStatusForApplications(appIds);
    },

    async fetchQuestionnaireStatusForApplications(applicationIds) {
      if (this.isAnonimous) return;
      const ids = (Array.isArray(applicationIds) ? applicationIds : [])
        .map((id) => Number(id))
        .filter((id) => Number.isInteger(id) && id > 0 && !this.questionnaireLoadedForApplicationIds[id]);

      if (ids.length === 0) return;

      try {
        const response = await this.$http.post('/api/v2/questions/steps/applications/status', {
          application_ids: ids,
        });
        const data = get(response, 'data.data', {}) || {};
        const merged = { ...this.questionnaireByApplicationId };
        ids.forEach((id) => {
          this.$set(this.questionnaireLoadedForApplicationIds, id, true);
          const value =
            (Object.prototype.hasOwnProperty.call(data, id) && data[id]) ||
            (Object.prototype.hasOwnProperty.call(data, String(id)) && data[String(id)]) ||
            null;
          if (value) {
            merged[id] = value;
          }
        });
        this.questionnaireByApplicationId = merged;
      } catch (error) {
        console.error(error);
      }
    },

    questionnaireStatusFor(vacancy) {
      const applicationId = get(vacancy, 'applications.0.id');
      if (!Number.isInteger(applicationId) || applicationId <= 0) return null;
      return this.questionnaireByApplicationId[applicationId] || null;
    },

    hasPrefetchedQuestionnaireFor(vacancy) {
      const applicationId = get(vacancy, 'applications.0.id');
      if (!Number.isInteger(applicationId) || applicationId <= 0) return false;
      return !!this.questionnaireLoadedForApplicationIds[applicationId];
    },

    referralForVacancy(vacancyId) {
      const id = Number(vacancyId);
      if (!Number.isInteger(id)) return null;
      const value = this.referralsByVacancyId[id];
      return value || null;
    },

    hasPrefetchedReferralFor(vacancyId) {
      const id = Number(vacancyId);
      if (!Number.isInteger(id)) return false;
      return !!this.referralsLoadedForVacancyIds[id];
    },

    handleApplicationsScopeChange() {
      if (this.applicationsScope === 'all' && !this.applicationsAllLoaded) {
        this.fetchAllApplications(1);
        return;
      }
      this.ensureReferralsForCurrentApplications();
    },

    onWithdrawn() {
      if (this.applicationsScope === 'all') {
        this.fetchAllApplications(this.applications_all_pagination_current || 1);
      } else {
        this.fetchVacanciesAndApplications();
      }
    },

    changeButton(i) {
      this.buttons.map((button, index) => {
        if (index === i) {
          button.activated = true;
        } else {
          button.activated = false;
        }
      });
      if (i !== 0) {
        this.closeBulkSelectionDrawer();
      }
      if (i === 2) {
        this.refreshApplicationsForCurrentScope();
        this.$nextTick(() => this.ensureReferralsForCurrentApplications());
      }
    },

    refreshApplicationsForCurrentScope() {
      // Limpa flags de prefetch in-memory para que indicações/questionários sejam
      // re-consultados (bulk) com base na lista atualizada.
      this.referralsLoadedForVacancyIds = {};
      this.questionnaireLoadedForApplicationIds = {};

      // Sempre refetch a aba "current" porque o usuário pode ter se candidatado
      // em massa (no Vacancy.vue) ou individualmente fora dessa view.
      this.fetchVacanciesAndApplications();

      if (this.applicationsScope === 'all') {
        this.applicationsAllLoaded = false;
        this.fetchAllApplications(this.applications_all_pagination_current || 1);
      }
    },
    toggleBulkSelectionMode() {
      this.isBulkApplying = !this.isBulkApplying;
      if (!this.isBulkApplying) {
        this.clearBulkSelection();
      }
    },
    toggleSimilarSelection(vacancyId) {
      if (this.selectedSimilarVacancyIds.includes(vacancyId)) {
        this.selectedSimilarVacancyIds = this.selectedSimilarVacancyIds.filter((id) => id !== vacancyId);
        return;
      }
      this.selectedSimilarVacancyIds = [...this.selectedSimilarVacancyIds, vacancyId];
    },
    toggleAllSimilarsOnPage() {
      if (this.allSimilarsOnPageSelected) {
        this.clearBulkSelection();
        return;
      }
      this.selectedSimilarVacancyIds = this.similars.map((vacancy) => vacancy.id);
    },
    clearBulkSelection() {
      this.selectedSimilarVacancyIds = [];
    },
    closeBulkSelectionDrawer() {
      this.isBulkApplying = false;
      this.clearBulkSelection();
    },
    openBulkConfirm() {
      if (this.selectedSimilarVacancyIds.length === 0 || this.isBulkSubmitting) return;
      this.bulkConfirmActive = true;
    },
    closeBulkConfirm() {
      if (this.isBulkSubmitting) return;
      this.bulkConfirmActive = false;
    },
    async submitBulkApplications() {
      if (this.selectedSimilarVacancyIds.length === 0 || this.isBulkSubmitting) return;

      this.isBulkSubmitting = true;
      try {
        const q = this.$route.query;
        const utmSource = Array.isArray(q.utm_source) ? q.utm_source[0] : q.utm_source;
        const utmCampaign = Array.isArray(q.utm_campaign) ? q.utm_campaign[0] : q.utm_campaign;
        const utmMedium = Array.isArray(q.utm_medium) ? q.utm_medium[0] : q.utm_medium;

        const payload = { vacancies: this.selectedSimilarVacancyIds };
        if (utmSource) {
          payload.channel = utmSource;
          payload.utm_source = utmSource;
        }
        if (utmCampaign) payload.utm_campaign = utmCampaign;
        if (utmMedium) payload.utm_medium = utmMedium;
        await this.$http.put("api/v1/applications/bulk", payload);
        this.$vs.notify({
          title: "Sucesso!",
          text: "Candidaturas em massa enviadas com sucesso.",
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "success",
        });
        this.bulkConfirmActive = false;
        this.closeBulkSelectionDrawer();
        if (this.similar_pagination_current && this.similar_pagination_path) {
          this.fetchSimilarPagination(this.similar_pagination_current);
        } else {
          this.fetchSimilarVacancies();
        }

        // Invalida as listas de candidaturas para que a aba "Candidaturas"
        // reflita as candidaturas recém-criadas sem precisar de reload.
        this.applicationsAllLoaded = false;
        this.applicationsAll = [];
        this.applications_all_total = 0;
        this.applications_all_pagination_current = 1;
        this.applications_all_pagination_path = '';
        this.questionnaireByApplicationId = {};
        this.questionnaireLoadedForApplicationIds = {};
        this.referralsLoadedForVacancyIds = {};
        this.fetchVacanciesAndApplications();
      } catch (error) {
        this.$vs.notify({
          title: "Falha ao se candidatar",
          text: "Não foi possível concluir a candidatura em massa. Tente novamente.",
          iconPack: "feather",
          icon: "icon-x-circle",
          color: "danger",
        });
        this.bulkConfirmActive = false;
      } finally {
        this.isBulkSubmitting = false;
      }
    },

    onMountButtonInAnonimous() {
      if (this.isAnonimous) {
        this.buttons[1].disabled = true;
        this.buttons[1].activated = false;
        this.buttons[2].activated = true;
        this.applicationsScope = 'all';
        if (!this.applicationsAllLoaded) {
          this.fetchAllApplications(1);
        }
      }
    },

    onWithoutApplication(_vacancy) {
      return (
        this.applications.filter((application) => application.id != _vacancy.id).length >
        0
      );
    },

    countVacancy() {
      let counter = 0;

      this.vacancies.map((vacancy) =>
        this.applications.map((application) => {
          if (vacancy.id !== application.id) counter++;
        })
      );
      return counter;
    },

    googleAnalytics() {
      const { company_label } = this.$router.history.current.params;
      this.$ga.page(`${company_label}/vacancy`);
    },

    handleEmpregosClick() {
      (async () => {
        try {
          const { trackEvent } = await import("@/services/posthog");
          trackEvent("recrutei_empregos_clicked");
        } catch (err) {
          console.log(err);
        }
      })();
      window.open('https://empregos.recrutei.com.br/?utm_source=talents-tab', '_blank');
    },

    handleTelegramClick() {
      (async () => {
        try {
          const { trackEvent } = await import("@/services/posthog");
          trackEvent("telegram_group_clicked");
        } catch (err) {
          console.log(err);
        }
      })();
      window.open('https://bit.ly/41MlTqG', '_blank');
    },

    async fetchPublicStatus() {
      try {
        const response = await this.$http.get("api/v2/talents/public/show");
        const { is_public = undefined } = response.data.data;

        if (!is_public) {
          this.is_public = false;
        } else {
          this.is_public = true;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async handleSignupClick() {
      this.$vs.loading({
        text: "Atualizando Visibilidade do Perfil",
      });
      try {
        await this.$http.post("api/v2/talents/public/set-public");
          this.$vs.notify({
            title: "Parabéns!",
            text: "Agora você faz parte da Base Recrutei!",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success"
          });
          this.is_public = true;
      } catch (error) {
        this.$vs.notify({
          title: "Ops!",
          text: "Ocorreu um erro ao atualizar a visibilidade do perfil.",
          iconPack: "feather",
          icon: "icon-x-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    checkForSuccess() {
      const q = this.$route.query.success;
      if (q == null || q === "") return;

      this.showSuccessModal();

      const query = { ...this.$route.query };
      delete query.success;
      this.$router.replace({
        name: "dashboard-vacancy",
        params: { ...this.$route.params },
        query,
      });
    },
    showSuccessModal() {
      this.showSuccessPopup = true;
      this.startConfettiEffect();
      setTimeout(() => {
        const popup = document.querySelector('.success-popup-backdrop');
        if (popup) {
          popup.style.transition = 'opacity 1s';
          popup.style.opacity = '0';
          setTimeout(() => {
            this.showSuccessPopup = false;
          }, 1000);
        }
      }, 3000);
      this.$store.dispatch("step/clearStepsState");
    },

    startConfettiEffect() {
      var count = 200;
      var defaults = {
        origin: { y: 0.4 }
      };
      const colors = [
        "#0857A0",
        "#3889D6",
      ]

      const shapes = [
        "star",
        "square",
        "circle",
      ]

      function fire(particleRatio, opts) {
        confetti({
          ...defaults,
          ...opts,
          particleCount: Math.floor(count * particleRatio),
          colors,
          shapes,
        });
      }

      fire(0.25, {
        spread: 26,
        startVelocity: 55,
      });
      fire(0.2, {
        spread: 60,
      });
      fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8,
      });
      fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2,
      });
      fire(0.1, {
        spread: 120,
        startVelocity: 45,
      });
    },
  },
  components: { VacancyCard, VacancyEmptyCard, ReLoading, Bolt, SkeletonLoader, RecrutestBanner, vSelect },
};
</script>

<style lang="scss">
.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: white;
  margin-left: 0.5rem;
  border-radius: 25%;
}

.buttons-wrapper {
  display: flex;
  justify-content: center;
  margin: 20px 0 30px 0;

  button {
    width: 150px;
    background: #fff;
    padding: 8px;
    border-radius: 3px 0 0 3px;
    border: 1px solid;
    font-weight: 500;
    cursor: pointer;
  }

  button:nth-child(2) {
    border-radius: 0 3px 3px 0;
  }

  .activated {
    background: #fff;
    color: #1551b1;
  }

  .desactivated {
    background: #fafafa;
    color: #cecece;
  }
}

.similar-loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  margin: 48px 0;

  .similar-loading-text {
    h2 {
      font-size: 18px;
      font-weight: 500;
      line-height: 21.09px;
      text-align: center;
      color: #4F4F4F;
    }
    p {
      font-size: 14px;
      font-weight: 400;
      line-height: 16.41px;
      text-align: center;
      text-decoration-skip-ink: none;
      color:  #696969;
    }
  }
}
</style>


<style lang="scss">
.nxp-nav-container {
  border-bottom: 0.5px solid #A8A8A8;
  background: #FFF;
}

.nxp-nav-button {
  display: flex;
  padding: 16px 4px 16px 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border: none;
  background-color: white;
  color: #696969;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-bottom: 2px solid #FFF;
  transition: all 0.2s ease;
  cursor: pointer;
}

.nxp-nav-button-active {
  border-bottom: 2px solid #059742;
  color: #333;
}

.nxp-vacancy-company {
  color: #4F4F4F;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.nxp-vacancy-list {
  color: #4F4F4F;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.nxp-vacancy-cards {
  padding: 24px 16px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  align-items: stretch;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;

  }

  > div {
    display: flex;
    height: 100%;
  }
}

.similar-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.similar-top-left-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}

.similar-bulk-actions-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.similar-pagination-inline-info {
  color: #696969;
  font-size: 14px;
}

.similar-pagination-summary-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.similar-pagination-link-action {
  border: none;
  background: transparent;
  color: #4169E1;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  text-decoration: none;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s ease;

  b {
    font-weight: 600;
  }

  &:hover {
    text-decoration: underline;
  }
}

.applications-header {
  align-items: center;
  gap: 12px;
}

.applications-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.applications-scope-vselect {
  min-width: 260px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #333;

  .vs__dropdown-toggle {
    padding: 2px 4px 4px 4px;
    border-radius: 8px;
    border: 0.5px solid #A8A8A8;
    background: #FFF;
    transition: border-color 0.2s ease;
    cursor: pointer;
  }

  .vs__selected {
    color: #333;
    font-size: 14px;
    font-weight: 500;
    margin: 4px 2px 2px 4px;
  }

  .vs__search,
  .vs__search:focus {
    margin: 0;
    padding: 0;
    cursor: pointer;
  }

  .vs__actions {
    padding: 0 6px 0 4px;
  }

  .vs__open-indicator {
    fill: #4F4F4F;
  }

  &.vs--open .vs__dropdown-toggle,
  &:hover .vs__dropdown-toggle {
    border-color: #4169E1;
  }

  .vs__dropdown-menu {
    border: 0.5px solid #A8A8A8;
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    padding: 4px;
    margin-top: 4px;
  }

  .vs__dropdown-option {
    border-radius: 6px;
    padding: 10px 12px;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    color: #333;
    white-space: normal;
  }

  .vs__dropdown-option--highlight {
    background: #4169E1;
    color: #FFF;
  }

  .vs__dropdown-option--selected {
    background: #C8E0FF;
    color: #1E3A8A;
  }

  .vs__dropdown-option--selected.vs__dropdown-option--highlight {
    background: #4169E1;
    color: #FFF;
  }
}

@media (max-width: 640px) {
  .applications-header {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .applications-header > .nxp-vacancy-company {
    display: none;
  }

  .applications-header-right {
    width: 100%;
    justify-content: space-between;
    gap: 8px;
  }

  .applications-scope-vselect {
    flex: 1;
    min-width: 0;
  }
}

@media (max-width: 768px) {
  .similar-top-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .similar-top-left-column {
    width: 100%;
  }

  .similar-pagination-summary-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .similar-bulk-actions-buttons {
    width: 100%;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 6px;
  }
}

.similar-vacancy-card-wrapper {
  position: relative;
  border-radius: 16px;
  transition: box-shadow 0.2s ease;
  overflow: hidden;
  display: flex;
  flex: 1;
  width: 100%;
}

.similar-vacancy-card-wrapper-selected {
  box-shadow: 0 0 0 2px #4169E1;
}

.similar-vacancy-checkbox {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 5;
  background: #FFF;
  border-radius: 8px;
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.similar-vacancy-checkbox::before {
  content: "";
  position: absolute;
  inset: -22px;
  border-radius: 16px;
}

.similar-vacancy-checkbox input[type="checkbox"] {
  accent-color: #4169E1;
  margin: 0;
  width: 22px;
  height: 22px;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.bulk-selection-drawer {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 16px;
  z-index: 100;
  background: #FFF;
  border-top: 1px solid #A8A8A8;
  border: 1px solid #A8A8A8;
  border-radius: 16px;
  box-shadow: 0 -6px 14px rgba(0, 0, 0, 0.08);
}

.bulk-selection-drawer-content {
  max-width: 1120px;
  margin: 0 auto;
  padding: 16px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.bulk-selection-count-text {
  color: #4F4F4F;
  font-size: 15px;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 8px;
}

.bulk-selection-count-number {
  color: #4F4F4F;
  font-weight: 400;
  line-height: 1;
}

.bulk-selection-drawer-actions {
  display: flex;
  gap: 8px;
}

.bulk-selection-drawer-actions .nxp-card-button-vacancy:disabled {
  opacity: 0.6;
  cursor: not-allowed;

  &:hover {
    background-color: #4169E1;
  }
}

.bulk-drawer-slide-enter-active,
.bulk-drawer-slide-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.bulk-drawer-slide-enter,
.bulk-drawer-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

.bulk-confirm-popup {
  .vs-popup {
    border-radius: 16px;
    max-width: 480px;
    width: 100%;
  }

  .vs-popup--header {
    background: #FFF;
    border-bottom: 1px solid #ECEBEB;
  }

  .vs-popup--title h3 {
    font-family: Roboto, sans-serif;
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }

  .vs-popup--content {
    padding: 24px;
  }
}

.bulk-confirm-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
}

.bulk-confirm-icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.bulk-confirm-title {
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  line-height: 1.3;
  margin: 0;
}

.bulk-confirm-highlight {
  color: #4169E1;
  white-space: nowrap;
}

.bulk-confirm-description {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #4F4F4F;
  line-height: 1.5;
  margin: 0;
  max-width: 380px;

  b {
    font-weight: 600;
    color: #333;
  }
}

.bulk-confirm-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
  flex-wrap: wrap;
}

.bulk-confirm-cancel.vs-button {
  color: #4F4F4F;
}

@media (max-width: 480px) {
  .bulk-confirm-actions {
    flex-direction: column-reverse;
    align-items: stretch;

    .vs-button {
      width: 100%;
    }
  }
}

.nxp-no-data {
  padding: 80px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.nxp-no-data p {
  max-width: 420px;
  color: #696969;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.nxp-other-oportunities {
  margin: 40px 0;
  display: flex;
  flex-direction: column;
  gap: 24px;

  svg {
    vertical-align: middle;
  }

  p {
    font-family: Roboto;
    font-size: 16px;
    font-weight: 400;
    line-height: 18.75px;
    text-align: left;
    color: #4F4F4F;
  }

  h3 {
    font-family: Roboto;
    font-size: 18px;
    font-weight: 400;
    line-height: 21.09px;
    text-align: left;
    color: #4F4F4F;
  }

  h4 {
    font-family: Roboto;
    font-size: 18px;
    font-weight: 500;
    line-height: 21.09px;
    text-align: left;
    color:#333333;
  }

  .featured-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 24px;
    justify-content: space-between;

    .featured {
      flex: 1 1 50%;
      padding: 16px;
      gap: 16px;
      border-radius: 16px;
      border: 0.5px solid #A8A8A8;
      display: flex;
      flex-direction: row;
      align-content: center;
      cursor: pointer;

    }
  }
  .hogwarts-card {
    height: 130px;
    display: flex;
    padding: 24px 16px 24px 160px;
    align-items: center;
    gap: 24px;
    border-radius: 16px;
    background: #ECEBEB;
    position: relative;
    cursor: pointer;
    margin-top: 24px;
  }
  .hogwarts-card img {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 160px;
    width: auto;
  }
  .hogwarts-card .content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 340px;
  }
  .hogwarts-card .content h3 {
    color: #333;
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .hogwarts-card .content p {
    color: #696969;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .quiz-button {
    display: flex;
    height: 48px;
    padding: 8px 32px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: #9B27B0;
    color: #FFF;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    border: none;
    cursor: pointer;
    margin-left: auto;
    transition: all ease 0.3s;
  }
  .quiz-button:hover {
    filter: brightness(0.9);
  }
  .talent-base {
    padding: 16px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    p {
      font-size: 14px;
      font-weight: 400;
      line-height: 16.41px;
    }
    
    .button-container {
      display: flex;
      flex-direction: row;
      gap: 16px;

      a {
        background: transparent;
        border: none;
        font-size: 16px;
        font-weight: 400;
        line-height: 18.75px;
        color: #4f4f4f;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .button-signup {
      background: #FFF;
      border: 1px solid #A8A8A8;
      color: #4F4F4F;
      font-size: 16px;
      font-weight: 400;
      line-height: 18.75px;
      padding: 8px 16px;
      border-radius: 8px;
      cursor: pointer;
      transition: all ease 0.3s;
    }
  }

  @media (max-width: 768px) {
    padding:16px;
    .featured-container {
      flex-direction: column;
      gap:8px;
    }
    .talent-base {
      .button-container {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }
    .hogwarts-card {
      height: auto;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 24px 16px;
      gap: 0;
    }
    .hogwarts-card img {
      position: static;
      height: 160px;
      width: auto;
      order: 2;
      margin-top: 16px;
      margin-bottom: 0;
    }
    .hogwarts-card .content {
      max-width: 100%;
      align-items: center;
      text-align: center;
      order: 1;
    }
    .hogwarts-card .content h3 {
      text-align: center;
    }
    .hogwarts-card .content p {
      text-align: center;
    }
    .quiz-button {
      width: 100%;
      margin-left: 0;
      margin-top: 0;
      order: 3;
    }
  }
}

.success-popup-backdrop {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 99;
  transition: all ease 0.3s;

  .success-popup {
    margin-top: 200px;
    background: #fff;
    font-family: Roboto;
    width: 380px;
    height: 116px;
    padding: 24px;
    gap: 16px;
    border-radius: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 0px 1px 0px #091E424F,
                0px 3px 5px 0px #091E4233;
                
    .success-popup-content {
      h2 {
        font-size: 22px;
        font-weight: 600;
        line-height: 25.78px;
        color: #333;
      }

      p {
        font-size: 16px;
        font-weight: 400;
        line-height: 18.75px;
        color: #4f4f4f;
      }
    }

    svg {
      flex-shrink: 0;
      width: 57px;
      height: 57px;
    }

  }
}
</style>